const appVersion = process.env.NEXT_PUBLIC_APP_VERSION || process.env.npm_package_version || "unknown";

export default appVersion;
